A human-readable description of the way in which the response choice selection will apply.

For example, the message can be:

- `I will only accept this answer`
- `I will accept any of these answers`
- `I will only accept this combination of answers`
- `I will accept above and including`
- `I will accept up to and including`
- `I will accept between this range`
